export class ExpiryUtilies {

  static calculateExpiryDate(annualVmExpiryDate: string, monthlyVmExpiryDate: string,  machineAutoRenewOn: number): Date | null {
    let date = Date.now();
    return  null;
    // if (!annualVmExpiryDate || !monthlyVmExpiryDate) {
    //   return null
    // }

    // const isEnvironmentAutoRenewOn = environmentAutoRenewOn === 1;
    // const isMachineAutoRenewOn = machineAutoRenewOn === 1;
    // const expiryDate = Date.now();

    // // Handle annual VMs
    // if (vmType === 'annual') {

    //     expiryDate.setFullYear(expiryDate.getFullYear() + 1); // Add one year

    //     // Environment auto-renew off
    //     if (!isEnvironmentAutoRenewOn) {

    //       // Both environment and machine auto-renew off
    //         if (!isMachineAutoRenewOn) {
    //             expiryDate.setMonth(expiryDate.getMonth() - 1); // One month before expiry
    //             expiryDate.setDate(parseInt(annualVmExpiryDate)); // Annual machines expire on the 15th if auto-renew is off
    //         }
    //         // Machine auto-renew on - do nothing extra, already set for next year

    //     // Environment auto-renew on
    //     } else {

    //         // Environment auto-renew on, machine auto-renew off
    //         if (!isMachineAutoRenewOn) {
    //             expiryDate.setMonth(expiryDate.getMonth() - 1); // One month before expiry
    //             expiryDate.setDate(parseInt(annualVmExpiryDate)); // Annual machines expire on the 15th if auto-renew is on
    //         }
    //         // Machine auto-renew on - do nothing extra, already set for next year
    //     }

    // // Handle monthly VMs
    // } else if (vmType === 'monthly') {

    //     expiryDate.setMonth(expiryDate.getMonth() + 1); // Add one month

    //     // Environment auto-renew off
    //     if (!isEnvironmentAutoRenewOn) {

    //         expiryDate.setDate(parseInt(monthlyVmExpiryDate)); // Monthly machines expire on the 20th if auto-renew is off
    //         // Machine auto-renew on - do nothing extra, already set for next month

    //     // Environment auto-renew on
    //     } else {
    //         expiryDate.setDate(parseInt(monthlyVmExpiryDate)); // Monthly machines expire on the 20th if auto-renew is on
    //         // Machine auto-renew on - do nothing extra, already set for next month
    //     }
    // }

    // return expiryDate;
}


}
